import { observer } from 'mobx-react';
import { useIdentitySync } from './identity';
import { useAnalyticsPageView } from './useAnalyticsPageView';

const AnalyticsBootstrap = observer((): null => {
  useIdentitySync();
  useAnalyticsPageView();
  return null;
});

export default AnalyticsBootstrap;
